import { css, SerializedStyles } from "@emotion/react";
import { kitText } from "../../styles";
import { ChipIntent } from "./types";
import { INTENT } from "../../constants";

export const CHIP_HEIGHT = "var(--spacing-24)";

const intent: Record<ChipIntent, SerializedStyles> = {
  [INTENT.INFO]: css`
    --icon-fill-color: var(--color-info);
    --chip-color-background: var(--color-background-info, #e5f6ff);
  `,
  [INTENT.SUCCESS]: css`
    --icon-fill-color: var(--color-success);
    --chip-color-background: var(--color-background-success, #ebfaeb);
  `,
  [INTENT.ERROR]: css`
    --icon-fill-color: var(--color-danger);
    --chip-color-background: var(--color-background-danger, #ffe5ea);
  `,
  // #e7e9ef should be --color-background-selected, but that variable is wrong in the default theme
  [INTENT.INACTIVE]: css`
    --icon-fill-color: var(--color-tertiary);
    --chip-color-background: #e7e9ef;
  `
};

export const styles = {
  outerWrapper: css`
    display: flex;
    align-items: center;
    gap: var(--spacing-8);
  `,
  wrapper: css`
    --icon-fill-color: var(--color-splash-primary);
    --chip-color-background: var(--color-splash-low-contrast, #e5eaff);
    color: var(--color-primary);
    background-color: var(--chip-color-background);
    ${kitText.variant.body}
    padding: var(--spacing-4) var(--spacing-8);
    border-radius: var(--spacing-4);
    max-height: ${CHIP_HEIGHT};
    gap: 3px;
    align-items: center;
    display: flex;
    flex: 1 1 0%;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-content: center;
    border: 1px solid transparent;
    &:focus {
      outline: none;
    }
    button svg {
      --icon-fill-color: var(--color-secondary);
    }
  `,
  isInteractive: css`
    cursor: pointer;
    &:focus {
      outline: none;
      border-color: var(--color-splash-primary);
    }
  `,
  isDisabled: css`
    --icon-fill-color: var(--color-secondary);
    background-color: var(--chip-disabled-color-background, #e7e9ef);
    border-color: transparent;
    color: var(--color-secondary);
  `,
  removeButton: css`
    background: none;
    border: none;
    padding: 0;
    outline: none;
    cursor: pointer;
    line-height: 0;
  `,
  label: css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  intent
};
